export default __webpack_public_path__ + "static/media/storageUnit1-afterA-1440w.f0427f2c.webp";